export enum SpConnectOrderTypeEnum {
  PurchaseOrder = 'PurchaseOrder',
  WorkOrder = 'WorkOrder',
  Memo = 'Memo',
  MeasurementPO = 'MeasurementPO',
  ExtraPO = 'ExtraPO',
  FixedContractPO = 'FixedContractPO',
  NotToExceedEPO = 'NotToExceedEPO',
  NotToExceedPO = 'NotToExceedPO',
}
